import { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import './DeleteModal.css';

const DeleteModal = ({ handleClose, show, id, onDelete }) => {
    const showHideClassName = show
        ? 'delete-modal display-block'
        : 'delete-modal display-none';
        
    const [deletedBy, setDeletedBy] = useState('');

    useEffect(() => {
        setDeletedBy(localStorage.getItem('badgeID'))
    }, [])

    const deleteBulletin = () =>  {
        onDelete({
            id,
            deletedBy
        });
    }

    return (
        <div className={showHideClassName}>
            <section className='delete-modal-main'>
                <Row>
                    <Col>
                        <h4 className='delete-modal-title'>Delete this bulletin?</h4>
                        <p>Are you sure you wish to delete this bulletin?</p>
                        <Button variant='danger' onClick={deleteBulletin}>Delete Bulletin</Button>
                        <Button variant='outline-primary' onClick={handleClose} style={{borderColor:'white'}}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </section>
        </div>
    );
};

export default DeleteModal;
